import { apiClient } from "../../../apiClient";
import { createIssueDataAdapter, issueTypesDataAdapter } from "./dataAdapters";
import { homePageUrls } from "./url";

export interface ICreateReportedIssueResponse {
  data: {
    jobId: number;
    number: string;
  };
}

export const createReportedIssue = async (data: any) => {
  const multipartFormData = createIssueDataAdapter(data);

  const { data: response } = await apiClient.post<
    any,
    ICreateReportedIssueResponse
  >(homePageUrls.createIssue, multipartFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response;
};

interface IGetIssueTypesParams {
  offset: number;
  adminId: number;
}

export interface IGetIssueTypesResponse {
  data: {
    items: {
      id: number;
      name: string;
      type: "issueType";
      meta: { imageLink: string };
    }[];
    count: number;
  };
}

export const getIssueTypes = async ({
  offset,
  adminId,
}: IGetIssueTypesParams) => {
  const { data } = await apiClient.get<
    IGetIssueTypesParams,
    IGetIssueTypesResponse
  >(homePageUrls.getIssueTypes, {
    params: { offset, adminId },
  });
  return issueTypesDataAdapter(data);
};
